import React, { useEffect, useState } from 'react';
import MainFrame from './component/MainUIFrame/MainFrame';
import Pages from './pages';
import NVBackdrop from './component/reusableUiComponent/NVBackdrop';
import NVSnackbar from './component/reusableUiComponent/NVSnackbar';
import NVPopover from './component/reusableUiComponent/NVPopover';
import { ConfirmProvider } from 'material-ui-confirm';
import { SnackbarProvider } from 'notistack';
import './styles/global.css';

import { auth, signOut, onAuthStateChanged } from './firebase';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loading from './component/Loader';
import { setSnackbarState } from './redux/features/snackbarSlice';
import { setProgress } from './redux/features/progressSlice';
import {
  ehrAPIBaseService,
  ehrAPIService,
  ehrAPIServiceMeta,
} from './http-common';
import {
  clearLoggedInUserData,
  setCurrentLoggedInUserData,
  setCurrentUserFrequentlyUsedCodes,
  setCurrentUserSettings,
  setLicensesData,
  setPermissions,
  setRoleAndLicenseHelperFunction,
  setTenantOrganization,
  setTenantPractitioner,
} from './redux/features/currentSlice';
import _, { isEmpty } from 'lodash';
import jwtDecode from 'jwt-decode';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';
import {
  LICENSE_BASED_PERMISSIONS,
  ROLE_BASED_PERMISSIONS,
} from './permissions/permissions';
import AlertPopUp from './component/Popup/AlertPopup';
import { getTenantFromToken } from './config/common';
import IdleController from './component/idle/IdleController';
import dayjs from 'dayjs';
import { ROLE_PROVIDER } from './pages/auth/constants';

function App() {
  let tenantOrganizationId = null;
  const reduxDispatch = useDispatch();

  const [networkStatus, setNetworkStatus] = useState(true);
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [myIntervalId, setMyIntervalId] = useState(null);
  const [isFirebaseLoaded, setIsFirebaseLoaded] = useState(false);
  const [isTenantLoaded, setIsTenantLoaded] = useState(false);
  const [isUserDataLoaded, setIsUserDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  const tenantOrganizationResource = useSelector(
    state => state?.current?.tenantOrganization
  );
  const selectedVersion = useSelector(
    state => state.changeVersion.selectedVersion
  );

  const loggedInUserData = useSelector(
    state => state?.current?.loggedInUserData
  );

  // const reduxLocationObject = useSelector(state => state?.router?.location);

  const [currentLocation, setCurrentLocation] = useState(null);

  const location = useLocation();

  console.log(networkStatus);

  const broadcastChannel = new BroadcastChannel('authChannel');
  broadcastChannel.addEventListener('message', event => {
    if (event.data.type === 'logout') {
      navigate('/login');
    }
  });

  const channel = new BroadcastChannel('user-login-channel');
  channel.onmessage = event => {
    if (event.data.type === 'user-login') {
      window.location.reload();
    }
  };

  useEffect(() => {
    setCurrentLocation(location?.pathname);
  }, [location]);

  const navigate = useNavigate();
  useEffect(() => {}, []);

  useEffect(() => {
    window.addEventListener('online', () => {
      reduxDispatch(
        setSnackbarState({
          open: true,
          message: 'Back online',
          type: 'success',
        })
      );
      setNetworkStatus(navigator.onLine);
    });
    window.addEventListener('offline', () => {
      reduxDispatch(
        setSnackbarState({
          open: true,
          message: 'You are offline',
          type: 'error',
        })
      );
      setNetworkStatus(navigator.onLine);
    });
    return () => {
      window.removeEventListener('online', () =>
        setNetworkStatus(navigator.onLine)
      );
      window.removeEventListener('offline', () =>
        setNetworkStatus(navigator.onLine)
      );
    };
  });

  const handleGetTenantOrganization = async () => {
    try {
      const jwtPayload = jwtDecode(localStorage.getItem('jwtToken'));
      const tenantId = jwtPayload?.firebase?.tenant; //'Enliv-Dev-cr017';
      if (jwtPayload?.enlivRoles?.includes(ROLE_PROVIDER)) {
        const response = await ehrAPIBaseService.get(
          `fhir/search/Practitioner?identifier=${jwtPayload?.user_id}`
        );

        reduxDispatch(
          setTenantPractitioner(response?.data?.entry?.[0]?.resource)
        );
      }
      const response = await ehrAPIBaseService.get(
        `fhir/search/Organization?identifier=${tenantId}`
      );

      if (response?.data?.entry?.length > 0) {
        const organizationResource = response?.data?.entry?.[0]?.resource;
        // debugger;
        if (
          organizationResource &&
          organizationResource?.contact?.[0]?.address?.state
        ) {
          organizationResource.contact[0].address.country = 'usa';
          tenantOrganizationId = organizationResource?.id;
        }
        reduxDispatch(setTenantOrganization(organizationResource));
        setIsTenantLoaded(true);
      }
    } catch (e) {
      console.error(e);
    } finally {
    }
  };

  const handleLogout = () => {
    signOut(auth)
      ?.then(() => {
        console.log(`signout successfull`);
        localStorage?.clear();
        // window.location.href = '/login';
        setFirebaseUser(null);
        setIsFirebaseLoaded(true);
      })
      .catch(e => {
        console.log(`some issue in firebase signout`, e);
      });
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      console.log(`Auth state changed`, user, auth);
      if (user) {
        if (user?.reloadUserInfo?.customAttributes?.includes('portal_user')) {
          setOpen(true);
          handleLogout();
          reduxDispatch(setProgress(false));

          return false;
        }
        setFirebaseUser(user);
        user
          ?.getIdToken()
          ?.then(token => {
            localStorage.setItem(`jwtToken`, token);
            localStorage.setItem(`username`, user?.displayName);
            localStorage.setItem(`loginAt`, user?.metadata?.lastSignInTime);
            // navigate(`/dashboard`);
            setIsFirebaseLoaded(true);
          })
          .catch(error => {
            console.log(`firebase auth error`, error);
            setFirebaseUser(null);
            setIsFirebaseLoaded(true);
            // navigate(`/login`);
          });
      } else {
        setFirebaseUser(null);
        setIsFirebaseLoaded(true);
        // navigate(`/login`);
      }
    });

    console.log(`APPJS AGAIN`, unsubscribe);

    return () => {
      unsubscribe();
    };
  }, []);

  const createUserSetting = async userId => {
    let setting = {
      theme: 'light',
      language: 'english',
    };
    let payload = {
      resourceType: 'Basic',
      code: {
        coding: [
          {
            system: 'http://enliv.com/code/basic-resource-type',
            code: 'user.preference.ui',
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format('YYYY-MM-DD'),
      extension: [
        {
          url: 'http://enliv.com/settings/data',
          valueString: JSON.stringify(setting),
        },
      ],
    };

    const response = await ehrAPIService.post(`createResource`, payload);
    return response;
  };

  const signoutInterval = () => {
    console.log(`signout interval called`);
    const lastSignInTime = new Date(
      auth?.currentUser?.metadata?.lastSignInTime
    )?.valueOf();
    const logoutTime = lastSignInTime + 0.0166667 * 60 * 60 * 1000; //2 hours from now
    const intervalId = setInterval(() => {
      const remainingTime = Math.max(0, logoutTime - Date.now());
      const hours = Math.floor(remainingTime / (60 * 60 * 1000));
      const minutes = Math.floor(
        (remainingTime % (60 * 60 * 1000)) / (60 * 1000)
      );
      const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);
      console.log(
        `Remaining time: ${hours} hours, ${minutes} minutes, and ${seconds} seconds`
      );

      if (remainingTime === 0) {
        clearInterval(intervalId);
        console.log('Time is up! Logging out user...');
        signOut(auth)
          ?.then(() => {
            console.log(`signout successfull`);
            localStorage?.clear();
            window.location.href = '/login';
          })
          .catch(e => {
            console.log(`some issue in firebase signout`, e);
          });
      }
    }, 1000);

    setMyIntervalId(intervalId);
  };

  const getParentKeys = (object, keyName, currentPath = []) => {
    if (typeof object !== 'object' || object === null) {
      return null;
    }
    if (keyName in object) {
      return [...currentPath];
    }
    for (const key in object) {
      const parentKeys = getParentKeys(object[key], keyName, [
        ...currentPath,
        key,
      ]);
      if (parentKeys !== null) {
        return parentKeys;
      }
    }
    return null;
  };

  let PERMISSIONS = {};
  const checkForPermissions = (
    rolePermissions,
    licensePermissions,
    roles,
    licenses
  ) => {
    Object.keys(rolePermissions).forEach(key => {
      if (
        typeof rolePermissions[key] === 'object' &&
        !rolePermissions[key].hasOwnProperty('administrator')
      ) {
        checkForPermissions(
          rolePermissions[key],
          licensePermissions[key],
          roles,
          licenses
        );
      } else {
        let keysParent = getParentKeys(ROLE_BASED_PERMISSIONS, key);
        if (keysParent) {
          _.set(
            PERMISSIONS,
            [...keysParent, key].join('.'),
            licenses.some(l => licensePermissions[key][l] === true) &&
              roles.some(l => rolePermissions[key][l] === true)
          );
        }
      }
    });
    return PERMISSIONS;
  };

  const isJsonString = str => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  let NEW_PERMISSIONS = {};
  const getNewPermissions = (data, roles) => {
    Object.keys(data).forEach(key => {
      if (
        typeof data[key] === 'object' &&
        !data[key].hasOwnProperty('administrator')
      ) {
        getNewPermissions(data[key], roles);
      } else {
        let keyData = getParentKeys(ROLE_BASED_PERMISSIONS, key);
        if (keyData) {
          _.set(
            NEW_PERMISSIONS,
            [...keyData, key].join('.'),
            roles.some(l => data[key][l] === true)
          );
        }
      }
    });
    return NEW_PERMISSIONS;
  };

  const getLoggedInUserData = async uid => {
    // const safeJSONParse = (str, fallbackValue = null) => {
    //   try {
    //     return JSON.parse(str);
    //   } catch (error) {
    //     return fallbackValue;
    //   }
    // };
    setIsUserDataLoaded(false);
    try {
      let response = await ehrAPIBaseService.get(
        'auth2/auth/getUser?uid=' + uid
      );
      let personDetail = await ehrAPIBaseService.get(
        '/fhir/search/?resourceType=Person&identifier=http://enliv.com/user/firebase-uid|' +
          uid
      );
      if (personDetail?.data?.entry?.[0]?.resource?.id) {
        let personId = personDetail?.data?.entry?.[0]?.resource?.id;
        let UserSetting = await ehrAPIBaseService.get(
          `fhir/search/?resourceType=Basic&code=user.preference.ui&subject=Person/${personId}`
        );
        if (UserSetting?.data?.total) {
          const rawData = { ...UserSetting?.data?.entry?.[0]?.resource };
          const displaySetting = rawData?.extension?.find(
            item => item?.url === 'http://enliv.com/settings/data'
          )?.valueString;
          if (displaySetting) {
            reduxDispatch(
              setCurrentUserSettings({
                resource: { ...rawData },
                display: JSON?.parse(displaySetting),
              })
            );
          }
        } else {
          const responseSetting = await createUserSetting(personId);
          console.log(responseSetting);
          if (responseSetting) {
            reduxDispatch(
              setCurrentUserSettings({
                resource: { ...responseSetting?.data },
                display: JSON?.parse(
                  responseSetting?.data?.extension?.[0]?.valueString
                ),
              })
            );
          }
        }
        getCPTBasic(personId);
      }

      if (response?.data?.userId) {
        reduxDispatch(setCurrentLoggedInUserData(response?.data));
        let responseServices = await ehrAPIServiceMeta.get(
          `/config/tenants/${getTenantFromToken()}/services`
        );
        const roles = response?.data?.roles;
        let licenses = [];
        if (responseServices?.data.length) {
          licenses = responseServices.data
            .filter(f => f.status === 'enabled')
            .map(m => {
              if (m.serviceName === 'eRx') return 'ehr_erx';
              else return m.serviceName;
            });
          licenses.push('scheduling');
          licenses.push('efax');
        }
        reduxDispatch(setLicensesData(licenses));
        let organizationSettings = await ehrAPIBaseService.get(
          `fhir/search/?resourceType=Basic&code=practice.roles.management&subject=Organization/${tenantOrganizationId}`
        );
        let defaultPermissions = true;
        if (organizationSettings?.data?.total) {
          let resourceData = organizationSettings?.data.entry?.[0]?.resource;
          let rolesData = resourceData?.extension.find(
            f => f.url === 'http://enliv.com/settings/role-permissions'
          );
          if (rolesData.valueString && isJsonString(rolesData.valueString)) {
            let newPermissions = getNewPermissions(
              JSON.parse(rolesData.valueString),
              roles
            );
            if (newPermissions) {
              defaultPermissions = false;
              reduxDispatch(setPermissions(newPermissions));
            }
          }
        }
        if (defaultPermissions) {
          reduxDispatch(
            setPermissions(
              checkForPermissions(
                ROLE_BASED_PERMISSIONS,
                LICENSE_BASED_PERMISSIONS,
                roles,
                licenses
              )
            )
          );
        }
        // if (!localStorage.getItem('permissions')) {
        //   localStorage.setItem(
        //     'permissions',
        //     selectedVersion === 'IN'
        //       ? 'ehr scheduling'
        //       : 'ehr ehr_erx claims scheduling telehealth'
        //   );
        // }
        // const licenses = localStorage.getItem('permissions')
        //   ? localStorage.getItem('permissions').split(' ')
        //   : selectedVersion === 'IN'
        //   ? ['ehr', 'scheduling']
        //   : ['ehr', 'ehr_erx', 'claims', 'scheduling', 'telehealth'];
        reduxDispatch(setRoleAndLicenseHelperFunction(getLoggedInUserData));
        setIsUserDataLoaded(true);
      }
    } catch (e) {
      console.error(e);
    } finally {
      reduxDispatch(setProgress(false));
    }
  };

  const getCPTBasic = async personId => {
    try {
      let response = await ehrAPIBaseService.get(
        `fhir/search/?resourceType=Basic&code=frequently.used.codes&subject=Person/${personId}`
      );
      if (response?.data?.total) {
        let resourceData = response?.data?.entry?.[0]?.resource;

        const displaySetting = resourceData?.extension?.find(
          item =>
            item?.url === 'http://enliv.com/settings/frequently-used-codes'
        )?.valueString;
        reduxDispatch(
          setCurrentUserFrequentlyUsedCodes({
            resource: { ...resourceData },
            display: displaySetting ? JSON?.parse(displaySetting) : '',
          })
        );

        // const procedure_codes = JSON?.parse(displaySetting)?.procedure_codes;

        // if(procedure_codes){
        //   localStorage.setItem(
        //     'procedureCodes',
        //     JSON.stringify(procedure_codes)
        //   );
        // }
      } else {
        await createCPTCodesOBjBasic(personId);
      }
    } catch (e) {
      console.error('error:', e?.message);
    }
  };

  const createCPTCodesOBjBasic = async personId => {
    let payload = {
      resourceType: 'Basic',
      code: {
        coding: [
          {
            system: 'http://enliv.com/code/basic-resource-type',
            code: 'frequently.used.codes',
          },
        ],
      },
      subject: {
        reference: `Person/${personId}`,
      },
      created: dayjs().format('YYYY-MM-DD'),
      extension: [
        {
          url: 'http://enliv.com/settings/frequently-used-codes',
          // valueString: '',
        },
      ],
    };
    try {
      const response = await ehrAPIService.post(`createResource`, payload);

      if (response?.data) {
        const rawData = { ...response?.data };

        reduxDispatch(
          setCurrentUserFrequentlyUsedCodes({
            resource: { ...rawData },
            // display: displaySetting ? JSON?.parse(displaySetting) : '',
          })
        );
      }
    } catch (e) {
      console.log('error');
    }
  };

  // const signoutWithoutInterval = () => {
  //   debugger;
  //   const lastSignInTime = new Date(
  //     auth?.currentUser?.metadata?.lastSignInTime
  //   )?.valueOf();
  //   const logoutTime = lastSignInTime + 0.0166667 * 60 * 60 * 1000; //2 hours from now
  //   const currentTime = new Date()?.valueOf();
  //   if (currentTime > logoutTime) {
  //     console.log('Time is up! Logging out user...');
  //     signOut(auth)
  //       ?.then(() => {
  //         console.log(`signout successfull`);
  //         localStorage?.clear();
  //         // window.location.href = "/login";
  //         navigate('/login');
  //       })
  //       .catch(e => {
  //         console.log(`some issue in firebase signout`, e);
  //       });
  //   }
  // };

  useEffect(() => {
    refreshUserData(firebaseUser, isFirebaseLoaded);
  }, [firebaseUser, isFirebaseLoaded]);

  const refreshUserData = async (firebaseUser, isFirebaseLoaded) => {
    if (isFirebaseLoaded) {
      if (firebaseUser) {
        reduxDispatch(setProgress(true));
        if (isEmpty(tenantOrganizationResource)) {
          await handleGetTenantOrganization();
        }
        if (isEmpty(loggedInUserData)) {
          await getLoggedInUserData(firebaseUser?.uid);
        }
        reduxDispatch(setProgress(false));
        if (currentLocation === '/login') {
          navigate(`/dashboard`, { replace: true });
        }
      } else {
        reduxDispatch(clearLoggedInUserData());
        if (currentLocation !== '/login') {
          navigate('/login', { replace: true });
        }
      }
    }
  };

  // useEffect(() => {
  //   const visitedFlag = window.sessionStorage.getItem('visitedFlag');
  //   if (!visitedFlag) {
  //     window.sessionStorage.setItem('visitedFlag', 'true');
  //     navigate('/');
  //   }
  // }, [navigate]);

  const logError = (error, info) => {
    // Do something with the error, e.g. log to an external API
    console.log(error, info);
  };

  return (
    <>
      <AlertPopUp open={open} setOpen={setOpen} />
      <IdleController handleLogout={handleLogout} />
      {isFirebaseLoaded &&
      ((firebaseUser !== null && isTenantLoaded && isUserDataLoaded) ||
        firebaseUser === null) ? (
        <>
          <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
            {/* <ConfirmProvider> */}
            <NVBackdrop />
            <MainFrame firebaseUser={firebaseUser} isOnline={networkStatus}>
              <Pages />
            </MainFrame>
          </ErrorBoundary>
          {/* </ConfirmProvider> */}
        </>
      ) : (
        <Loading isLoading isFade />
      )}
    </>
  );
}

export default App;
